import { useContext, useState, useEffect, useRef } from "react";

import {
  Platform,
  StyleSheet,
  View,
  Text,
  ScrollView,
} from "react-native";
import SafeAreaView from "../components/SafeAreaView";

//import Ionicons from "react-native-vector-icons/Ionicons";
import { Ionicons } from "../components/VectorIcons";

import CustomButton from "../components/CustomButton";
import InputField from "../components/InputField";
import { AuthContext } from "../context/AuthContext";
import PageHeader from "../components/PageHeader";
import * as Config from "../config";
import axios from "axios";
import qs from "qs";
import { EventRegister } from "react-native-event-listeners";
import SimplePress from "../components/SimplePress";
import Slider from "@react-native-community/slider";
import { ChipType, dateValue, getSchemeStyle } from "../context/helper";
import ActivityScreen from "./activityscreen";


const ChangeBoardScreen = ({ navigation, route }) => {
  const schemeStyles = getSchemeStyle();

  const [dataLoaded, setDataLoaded] = useState(false);
  const { userToken, useFirm, userInfo, isService, serviceBoardInfo } =
    useContext(AuthContext);
  const { boardid, changepoint } = route.params;

  const [sendInterval, setSendInterval] = useState(120);
  const [bssid, setBssid] = useState("");
  const [boardData, setBoardData] = useState();
  const [selMPID, setSelMPID] = useState(0);
  const [pointsData, setPointsData] = useState(null);

  const sensorName = useRef();
  const branchName = useRef();
  const firmID = useRef();
  const firmName = useRef();

  const loadedBoard = useRef();
  const loadedPoints = useRef();

  const [resultText, setResultText] = useState("");

  const MPHeader = (props) => {
    return (
      <View style={mpStyles.mpHeaderContainer}>
        <Text style={[mpStyles.mpHeaderText,schemeStyles.BorderC,schemeStyles.defaultText]}>{props.data.name}</Text>
      </View>
    );
  };
  const MPItem = (props) => {
    return (
      <SimplePress onPress={props.onPress}>
        <View style={mpStyles.mpItemContainer}>
          <View style={[mpStyles.mpItemCheck,schemeStyles.BorderC]}>
            <View
              style={[
                mpStyles.mpItemInnerCheck,
                props.selected && { backgroundColor: schemeStyles.checkColors.backgroundColor},
              ]}
            ></View>
            {props.selected && (
              <Ionicons
                style={{ position: "absolute", right: Platform.OS==="web"?-2:2, bottom: -3 }}
                name="checkmark-outline"
                size={32}
                color={schemeStyles.checkColors.foregroundColor}
              />
            )}
          </View>
          <View style={mpStyles.mpItemTextContainer}>
            <Text style={[mpStyles.mpItemText,schemeStyles.defaultText]}>{props.data.name}</Text>
            {props.assigned && (
              <View style={mpStyles.mpAssignedContainer}>
                <Text style={[mpStyles.mpAssignedText,{color: schemeStyles.checkColors.assignColor}]}>zugewiesen</Text>
              </View>
            )}
          </View>
        </View>
      </SimplePress>
    );
  };
  

  const MeasuringPoints = (props) => {
    const mapPoints = (pts) => {
      let mps = [];
      let bid = 0;
  
      mps.push(
        <MPItem
          key={`P_0`}
          data={{ id: 0, name: "keine Messstelle (Reserve)" }}
          selected={props.selectedID == 0}
          onPress={() => {
            if (props.onPress) props.onPress(0, null, null);
          }}
        />
      );
  
      if (pts) {
        pts.forEach((pt) => {
          if (pt.branchid !== bid) {
            // Add Header
            mps.push(
              <MPHeader
                key={`H_${pt.branchid}`}
                data={{ id: pt.branchid, name: pt.branchname }}
              />
            );
            bid = pt.branchid;
          }
          mps.push(
            <MPItem
              key={`P_${pt.id}`}
              data={pt}
              selected={props.selectedID == pt.id}
              assigned={pt.boardid != 0 && pt.boardid != props.ownBoardID}
              onPress={() => {
                if (props.onPress) props.onPress(pt.id, pt.name, pt.branchname);
              }}
            />
          );
        });
      }
  
      return mps;
    };
  
    return (
      <View>
        <Text style={[mpStyles.headerText,schemeStyles.silverText]}>Messstelle zuweisen</Text>
        {mapPoints(props.data)}
      </View>
    );
  };

  const loadData = async () => {
    setDataLoaded(false);

    const url = `${Config.BASE_URL}/getdata`;
    let data = {
      action: "boardchange",
      firmid: useFirm.current,
      boardid: boardid,
      points: changepoint ? 1 : 0,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        let _boarddata = res.data;
        //console.log(_boarddata);
        if (_boarddata && _boarddata.result == "OK") {

          loadedBoard.current = _boarddata.data;

          if (_boarddata.points) {
            let pt = _boarddata.points.find(
              (data) => data.id === _boarddata.data.messid
            );
            sensorName.current = pt?.name;
            branchName.current = pt?.branchname;
          }
          firmID.current = _boarddata.data.firmid;
          firmName.current = _boarddata.data.firmname;

          setSendInterval(_boarddata.data.interval / 60);
          setBssid(_boarddata.data.bssid);
          setBoardData(_boarddata.data);
          setSelMPID(_boarddata.data.messid);
          if (changepoint) {
            loadedPoints.current = _boarddata.points;
            setPointsData(_boarddata.points);
          }
        }
      })
      .catch((e) => {
        console.log(`BoardChange error ${e}`);
      });
    setDataLoaded(true);
  };

  const loadPoints = async (fid) => {
    setDataLoaded(false);

    const url = `${Config.BASE_URL}/getdata`;
    let data = {
      action: "loadmeasuringpoints",
      firmid: fid,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        let _pointdata = res.data;
        //console.log(_pointdata);
        if (_pointdata && _pointdata.result == "OK") {
          setPointsData(_pointdata.points);

          sensorName.current = "";
          branchName.current = "";
          setSelMPID(0);
        }
      })
      .catch((e) => {
        console.log(`LoadMeasuringPoints error ${e}`);
      });
    setDataLoaded(true);
  };

  const saveBoardData = async (bID, bInterval, bBssid, bMessID, bNewFirmID) => {
    return new Promise(async (resolve, reject) => {
      const url = `${Config.BASE_URL}/getdata`;
      let data = {
        action: "boardsave",
        firmid: useFirm.current,
        boardid: bID,
        interval: bInterval,
        bssid: bBssid,
        messid: bMessID,
      };
      if (bNewFirmID !== false) data = { ...data, newfirmid: bNewFirmID };

      console.log(data);
      let options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + userToken,
        },
        data: qs.stringify(data),
        url,
      };
      await axios(options)
        .then((res) => {
          let _data = res.data;
          //console.log(_data);
          if (_data && _data.result == "OK") {
            resolve({ result: "OK", reason: "" });
          } else if (_data && _data.result == "Failed")
            reject({ result: "Failed", code: 200, reason: "" });
        })
        .catch((e) => {
          console.log(e);
          reject({
            result: "Failed",
            code: e.response.status,
            reason: e.response.data,
          });
        });
    });
  };

  const macAddressMask = (input) => {
    const MAC_ADDRESS_WITH_MASK = 17;
    const setCharacters = new Set([
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
    ]);
    let res = "";
    let idxAtMask = -1;
    for (let idx = 0; idx < input.length; idx++) {
      let currChar = input.charAt(idx);
      if (setCharacters.has(currChar)) {
        if (idxAtMask === 1) {
          res += ":";
          idxAtMask = -1;
        }
        res += currChar;
        idxAtMask++;
      }
    }

    if (res.length <= MAC_ADDRESS_WITH_MASK) {
      return res.toUpperCase();
    } else {
      return res.substring(0, MAC_ADDRESS_WITH_MASK).toUpperCase();
    }
  };

  const fieldCheck = (brName, brAdress) => {
    return brName.length > 0 && brAdress.length > 0;
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    const emitSubscribe = EventRegister.addEventListener(
      Config.Events.FIRM_SELECT,
      (msg) => {
        if (boardData.firmid !== msg.firmid) {
          setBoardData({
            ...boardData,
            firmid: msg.firmid,
            firmname: msg.firmname,
          });
          firmID.current = msg.firmid;
          firmName.current = msg.firmname;

          if (loadedBoard.current.firmid === msg.firmid) {
            setPointsData(loadedPoints.current);

            let pt = loadedPoints.current.find(
              (item) => item.id === loadedBoard.current.messid
            );
            sensorName.current = pt ? pt.name : "";
            branchName.current = pt ? pt.branchname : "";
            setSelMPID(pt ? pt.id : 0);
          } else loadPoints(msg.firmid);
        }
      }
    );
    return () => {
      EventRegister.removeEventListener(emitSubscribe);
    };
  }, [boardData]);

  if (!dataLoaded) {
    return (
      <ActivityScreen />
    );
  }

  const prodDate = (date) => {
    if (new Date(date).getTime() == -3600000)
      return 'unbekannt';
    else
      return dateValue(date);
  }
  return (
    <SafeAreaView style={[styles.mainArea,schemeStyles.Background]}>
      <PageHeader navigation={navigation} showBack={true} />
      <ScrollView style={styles.mainContainer}>
        <View style={styles.topBox}>
          <Text style={[styles.titleText,schemeStyles.grayText]}>Einstellungen Sensorbox</Text>
        </View>
        <View>
          <Text style={[styles.boardIDText,schemeStyles.defaultText]}>{`Sensorbox #${boardid}`}</Text>
        </View>
        {boardData ? (
          <>
            <View style={[styles.boardContainer,schemeStyles.BorderC]}>
              <View style={styles.boardLine}>
                <Text style={[styles.boardInfoText, styles.boardInfoMainCol,schemeStyles.defaultText]}>
                  Boardtoken:
                </Text>
                <Text style={[styles.boardInfoText,schemeStyles.defaultText]}>{boardData.token}</Text>
              </View>
              <View style={styles.boardLine}>
                <Text style={[styles.boardInfoText, styles.boardInfoMainCol,schemeStyles.defaultText]}>
                  Boardversion:
                </Text>
                <Text style={[styles.boardInfoText,schemeStyles.defaultText]}>
                  {boardData.boardversion ? boardData.boardversion : "n.A."}
                </Text>
              </View>
              <View style={styles.boardLine}>
                <Text style={[styles.boardInfoText, styles.boardInfoMainCol,schemeStyles.defaultText]}>
                  Chiptyp:
                </Text>
                <Text style={[styles.boardInfoText,schemeStyles.defaultText]}>
                  {ChipType.chipName(boardData.chiptype)}
                </Text>
              </View>
              <View style={styles.boardLine}>
                <Text style={[styles.boardInfoText, styles.boardInfoMainCol,schemeStyles.defaultText]}>
                  Produktionsdatum:
                </Text>
                <Text style={[styles.boardInfoText,schemeStyles.defaultText]}>
                  {prodDate(boardData.producedate)}
                </Text>
              </View>
            </View>
            <View style={[styles.sliderContainer,schemeStyles.BorderC]}>
              <View style={styles.sliderHeader}>
                <Ionicons name="play-forward-outline" size={24} color={schemeStyles.grayIcon.color} />
                <Text style={[styles.sliderHeaderText,schemeStyles.grayText]}>Sendeintervall</Text>
                <Text style={[styles.sliderHeaderValue,schemeStyles.defaultText]}>{`${sendInterval}min (${
                  sendInterval / 60
                }h)`}</Text>
              </View>
              <Slider
                style={{
                  flex: 1,
                  height: 20,
                }}
                minimumValue={60}
                maximumValue={360}
                minimumTrackTintColor="#cacaca"
                thumbTintColor="#4785b8"
                value={sendInterval}
                onValueChange={(val) => {
                  setSendInterval(val);
                }}
                step={30}
              />
              <View style={styles.sliderInfo}>
                <View
                  style={[styles.sliderInfoField, styles.sliderMarginFields]}
                >
                  <Text></Text>
                </View>
                <View style={styles.sliderInfoField}>
                  <SimplePress
                    hitSlop={5}
                    onPress={() => {
                      setSendInterval(120);
                    }}
                  >
                    <Text style={schemeStyles.defaultText}>2h</Text>
                  </SimplePress>
                </View>
                <View style={styles.sliderInfoField}>
                  <Text></Text>
                </View>
                <View style={styles.sliderInfoField}>
                  <SimplePress
                    hitSlop={5}
                    onPress={() => {
                      setSendInterval(240);
                    }}
                  >
                    <Text style={schemeStyles.defaultText}>4h</Text>
                  </SimplePress>
                </View>
                <View style={styles.sliderInfoField}>
                  <Text></Text>
                </View>
                <View
                  style={[styles.sliderInfoField, styles.sliderMarginFields]}
                >
                  <SimplePress
                    hitSlop={5}
                    onPress={() => {
                      setSendInterval(360);
                    }}
                  >
                    <Text style={schemeStyles.defaultText}>6h</Text>
                  </SimplePress>
                </View>
              </View>
            </View>
            <InputField
              style={[styles.inputField,schemeStyles.BorderC,schemeStyles.defaultText,schemeStyles.placeholderText]}
              label={"MAC Router/Repeater - BSSID"}
              icon={<Ionicons name="radio-outline" size={24} color={schemeStyles.grayIcon.color} />}
              value={bssid}
              onChangeText={(text) => setBssid(macAddressMask(text))}
            />
            {changepoint && userInfo.current.R_Admin && (
              <View style={[styles.firmContainer,schemeStyles.BorderC]}>
                <Text style={[styles.firmHeader,schemeStyles.silverText]}>Firma</Text>
                <View style={styles.firmLine}>
                  <Text style={[styles.firmText,schemeStyles.defaultText]}>
                    {boardData.firmid
                      ? boardData.firmname
                      : "- keine Firma zugewiesen"}
                  </Text>
                  <SimplePress
                    onPress={() => {
                      navigation.navigate("FirmScreen", {
                        screen: "FirmSelect",
                        params: { firmid: boardData.firmid },
                      });
                    }}
                  >
                    <Ionicons name="ellipsis-vertical" size={30} color={schemeStyles.grayIcon.color} />
                  </SimplePress>
                </View>
              </View>
            )}
            {changepoint && (
              <MeasuringPoints
                data={pointsData}
                selectedID={selMPID}
                ownBoardID={boardData.id}
                onPress={(id, name, branchname) => {
                  sensorName.current = name;
                  branchName.current = branchname;

                  setSelMPID(id);
                }}
              />
            )}
            <View style={styles.resultContainer}>
              <Text style={schemeStyles.resultText}>{resultText}</Text>
            </View>
          </>
        ) : (
          <View>
            <Text>Keine Daten</Text>
          </View>
        )}
        <View style={styles.buttonContainer}>
          <CustomButton
            style={[styles.buttons,schemeStyles.buttonText]}
            onPress={() => {
              if (
                loadedBoard.current.interval != sendInterval * 60 ||
                loadedBoard.current.bssid != bssid ||
                loadedBoard.current.messid != selMPID ||
                loadedBoard.current.firmid != firmID.current
              ) {
                saveBoardData(
                  boardid,
                  sendInterval * 60,
                  bssid,
                  selMPID,
                  loadedBoard.current.firmid != firmID.current
                    ? firmID.current
                    : false
                )
                  .then((res) => {
                    //console.log(res);
                    EventRegister.emit(Config.Events.BOARD_CHANGE, {
                      boardid: boardid,
                      interval: sendInterval,
                      bssid: bssid,
                      messid: selMPID,
                      sensorname: sensorName.current,
                      branchname: branchName.current,
                      firmid: firmID.current,
                      firmname: firmName.current,
                    });
                    navigation.goBack();
                  })
                  .catch((res) => {
                    setResultText(res.reason);
                  });
              } else navigation.goBack();
            }}
          >
            OK
          </CustomButton>
          <View style={styles.spacer} />
          <CustomButton
            style={[styles.buttons, styles.backButton,schemeStyles.buttonText]}
            onPress={() => {
              navigation.goBack();
            }}
          >
            Zurück
          </CustomButton>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default ChangeBoardScreen;

const sliderMargin = (os) => {
  switch (os) {
    case "android":
      return 10;
    case "web":
      return 1;
    case "ios":
      return 5;
  }
  return 0;
};

const mpStyles = StyleSheet.create({
  headerText: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
    marginBottom: 5,
  },
  mpHeaderContainer: {},
  mpHeaderText: {
    fontFamily: "Roboto-Italic",
    fontSize: 16,
    marginBottom: 5,
    borderBottomWidth: 1,
    marginTop: 10,
  },
  mpItemContainer: {
    flexDirection: "row",
    marginVertical: 10,
    alignItems: "center",
  },
  mpItemCheck: {
    width: 30,
    height: 30,
    borderWidth: 1,
    marginRight: 10,
  },
  mpItemInnerCheck: {
    width: 24,
    height: 24,
    position: "absolute",
    top: 2,
    left: 2,
  },
  mpItemTextContainer: {
    flex: 1,
    height: 45,
    justifyContent: "center",
  },
  mpItemText: {
    fontFamily: "Roboto-Regular",
    fontSize: 16,
  },
  mpAssignedContainer: {
    position: "absolute",
    bottom: 0,
  },
  mpAssignedText: {
    fontFamily: "Roboto-Regular",
    fontSize: 12,
  },
});

const styles = StyleSheet.create({
  mainArea: {
    flex: 1,
    paddingTop: 20,
  },
  mainContainer: {
    paddingHorizontal: 25,
  },
  titleText: {
    fontFamily: "Roboto-Medium",
    fontSize: 28,
    fontWeight: "500",
  },
  inputField: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
    marginBottom: 20,
    height: 60,
  },
  buttonContainer: {
    flexDirection: "row",
  },
  buttons: {
    flex: 1,
  },
  backButton: {
    backgroundColor: "#555",
  },
  spacer: {
    width: 10,
  },
  resultContainer: {
    marginBottom: 10,
  },
  sliderContainer: {
    borderBottomWidth: 1,
    paddingBottom: 20,
    marginBottom: 10,
  },
  sliderHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  sliderHeaderText: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
    marginLeft: 5,
    flex: 1,
  },
  sliderHeaderValue: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
  },
  sliderInfo: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginRight: sliderMargin(Platform.OS),
    marginLeft: sliderMargin(Platform.OS) + 7,
  },
  sliderInfoField: {
    flexDirection: "row",
    justifyContent: "center",
  },
  sliderMarginFields: {},
  boardIDText: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
  },
  boardLine: {
    flexDirection: "row",
    marginBottom: 5,
  },
  boardInfoMainCol: {
    width: 120,
  },
  boardInfoText: {
    fontFamily: "Roboto-Regular",
    fontSize: 12,
    flexWrap: "nowrap",
  },
  topBox: {
    marginBottom: 20,
  },
  boardContainer: {
    borderBottomWidth: 1,
    borderTopWidth: 1,
    marginTop: 5,
    marginBottom: 20,
    paddingTop: 5,
  },
  firmContainer: {
    borderBottomWidth: 1,
    marginBottom: 10,
    paddingBottom: 10,
  },
  firmHeader: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
    marginBottom: 10,
  },
  firmLine: {
    flexDirection: "row",
    justifyContent: "center",
  },
  firmText: {
    fontFamily: "Roboto-Regular",
    fontSize: 16,
    flex: 1,
  },
});
